module.exports = __webpack_public_path__ + "static/media/dark@2x.cf777f77.png";